// import * as MeScroll from 'mescroll.js'
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let H3Scroll = class H3Scroll extends Vue {
    constructor() {
        super(...arguments);
        this.mescroll = null;
    }
    mounted() {
        const MeScroll = require("mescroll.js");
        // debugger;
        const self = this;
        self.mescroll = new MeScroll(`${this.wrapId}`, {
            up: {
                auto: this.autoUp,
                use: this.enableUp,
                page: { size: self.pageSize },
                callback: self.upCallback,
                // 默认为可回弹，兼容ios 9.0
                isBounce: true,
                htmlNodata: `<p class="upwarp-nodata">${self.noMoreMessage}</p>`,
                warpId: this.wrapId,
                isLock: this.isLock,
                onScroll: self.scroll
                // empty: {
                //   icon: 'src/assets/img/blankpage.png',
                //   tip: 'shishishi ',
                // },
            },
            down: {
                use: this.enableDown,
                auto: true
            }
        });
        // self.mescroll.optUp.onScroll = (mescroll, y, isUp) => {
        //   // debugger
        //   if (self.scroll) {
        //     self.scroll(mescroll, y, isUp)
        //   }
        // }
        self.mescroll.lockUpScroll(this.isLock);
    }
    upCallback(page) {
        const self = this;
        if (self.loadMore) {
            self.loadMore(page, (length, total) => {
                self.mescroll.endBySize(length, total);
            }, () => {
                self.mescroll.endErr();
            });
        }
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3Scroll.prototype, "isLock", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "enableDown", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "enableUp", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "refresh", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "loadMore", void 0);
tslib_1.__decorate([
    Prop({
        default: 10
    })
], H3Scroll.prototype, "pageSize", void 0);
tslib_1.__decorate([
    Prop({
        default: '已加载全部数据'
    })
], H3Scroll.prototype, "noMoreMessage", void 0);
tslib_1.__decorate([
    Prop({
        default: 'list-scroller'
    })
], H3Scroll.prototype, "wrapId", void 0);
tslib_1.__decorate([
    Prop()
], H3Scroll.prototype, "scroll", void 0);
tslib_1.__decorate([
    Prop({
        default: true
    })
], H3Scroll.prototype, "autoUp", void 0);
H3Scroll = tslib_1.__decorate([
    Component({
        name: 'h3-scroll',
        components: {}
    })
], H3Scroll);
export default H3Scroll;
